<template>
  <div class="contract-list">
    <div>
      <el-row class="filter-wrap" :gutter="20">
        <el-col :span="5">
          <el-input v-model="form.code" size="small" placeholder="批次名称" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="5">
          <el-input v-model="form.applicantName" size="small" placeholder="开票申请人" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="default" size="small" @click="onReset">重置</el-button>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="table-wrap">
      <el-row class="table-count-wrap" :gutter="20">
        <el-col :span="10">
          <p class="table-count">
            <span>开票总数：{{ page.total }}条</span>
          </p>
        </el-col>
      </el-row>
      <el-table v-loading="tableLoading" :data="tableData" size="small">
        <el-table-column label="批次名称" prop="batchName" align="center"></el-table-column>
        <el-table-column label="开票申请人" prop="applicantName" align="center"></el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
        <el-table-column label="开票主体" prop="finAccountName" align="center"></el-table-column>
        <el-table-column label="开票金额" prop="invoiceMoney" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.invoiceMoney) }}
          </template>
        </el-table-column>
        <el-table-column label="开票类型" prop="invoiceType" align="center">
          <template slot-scope="scope">
            {{ billingConfig.getAppointed("status", scope.row.invoiceType) }}
          </template>
        </el-table-column>
        <el-table-column label="开票明细" prop="invoiceDetail" align="center">
          <template slot-scope="scope">
            {{
              billingConfig.getAppointed(
                "invoice_status",
                scope.row.invoiceDetail
              )
            }}
          </template>
        </el-table-column>

        <el-table-column label="审批时间" prop="auditTime" align="center" width="150" v-if="type === 'Processing'"></el-table-column>
        <el-table-column label="审批状态" prop="auditStatus" align="center">
          <template slot-scope="scope">
            <p>
              {{ approveConfig.getAppointed("statusEnd", scope.row.auditStatus, "") }}
            </p>
          </template>
        </el-table-column>
        <!-- 具体状态在const-config-approve.js里 懒得写魔法数字了 -->
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="type === 'ExamineProcessing'" type="text" size="small" @click="toAssess(scope.row.id)">审批</el-button>
            <el-button v-if="type === 'Processing'" type="text" size="small" @click="toDetail(scope.row.id)">明细</el-button>
            <el-button v-if="type === 'Processing'&&object===7&&scope.row.auditStatus===19" type="text" size="small" @click="toAssess(scope.row.id)">重审</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
  </div>
</template>

<script>
import validate from "@/util/validate";
import util from "@/util/util";
import { contractConfig } from "@/const/config/invoice";
import { billingConfig } from "@/const/config/billing";
import { invoiceBatchList, invoiceDetail } from "@/api/approve/invoice";
import { customConfig } from "@/const/config/custom";
import { approveConfig } from "@/const/config/approve";

export default {
  props: ["type"],
  data() {
    var that = this;
    return {
      approveConfig,
      Detaildialog: false,
      contractConfig: contractConfig,
      billingConfig,
      pickerMin: {
        disabledDate(time) {
          if (validate.checkNull(that.form.endTime)) return false;
          return time.getTime() > new Date(that.form.endTime).getTime();
        },
      },
      pickerMax: {
        disabledDate(time) {
          if (validate.checkNull(that.form.startTime)) return false;
          return time.getTime() < new Date(that.form.startTime).getTime();
        },
      },
      //调整监测时间规则
      timeOptionRange: "",
      jobRangePicker: {
        onPick: (time) => {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: (time) => {
          let t = new Date(dateFormat(new Date()).split(" ")[0] + " 00:00:00");
          let timeOptionRange = this.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 6 * 1000;
          if (timeOptionRange) {
            return (
              time.getTime() <= t.getTime() ||
              time.getTime() < timeOptionRange.getTime() - secondNum ||
              time.getTime() > timeOptionRange.getTime() + secondNum
            );
          }
          return time.getTime() <= t.getTime();
        },
      },
      form: {
        batchName: "", //批次名称
        applicantName: "", //开票申请人
      },

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      object:'',
      tableData: [],
      tableLoading: false,
    };
  },
  mounted() {
    // console.log(this.$route.query.id);
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        batchName: "",
        applicantName: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      queryObj.auditFlag = customConfig.Status[this.type];
      console.log("queryObj", queryObj);
      this.tableLoading = true;
      invoiceBatchList(queryObj)
        .then((res) => {
          console.log(res.data);
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.object=res.object
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 跳转到审批页
     */
    toAssess(id) {
      let router = this.$router.push({
        path: "/check/invoiceBatch/assess",
        query: {
          id,
          flag:"approve"
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },


    toDetail(id) {
      let router = this.$router.push({
        path: "/check/invoiceBatch/assess",
        query: {
          id,
          flag:""
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    /**
     * 展示原因
     * @param text 原因类型
     * @param reason 原因
     */
    onShowReason(text, reason) {
      reason = reason || "";
      this.$alert(reason, text, {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
};
</script>

<style lang="scss" scoped>
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  span {
    margin-right: 20px;
  }
}
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    min-height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
// 弹出框body
/deep/.el-dialog__body {
  padding-top: 0 !important;
  .mb-10 {
    margin-bottom: 10px;
  }
}
</style>